@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');

@font-face {
  font-family: "Dirham";
  src:
    url("../node_modules/dirham/dist/fonts/dirham.woff2") format("woff2"),
    url("../node_modules/dirham/dist/fonts/dirham.woff") format("woff"),
    url("../node_modules/dirham/dist/fonts/dirham.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  unicode-range: U+20C3;
  size-adjust: 82%;
}

@font-face {
  font-family: "Dirham-Sans";
  src:
    url("../node_modules/dirham/dist/fonts/sans/dirham-sans.woff2") format("woff2"),
    url("../node_modules/dirham/dist/fonts/sans/dirham-sans.woff") format("woff"),
    url("../node_modules/dirham/dist/fonts/sans/dirham-sans.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  unicode-range: U+20C3;
  size-adjust: 82%;
}
:root {
  --bg-primary: #0a0b10;
  --bg-secondary: #121420;
  --bg-card: rgba(24, 28, 47, 0.65);
  --bg-input: #1b1e32;
  --accent-cyan: #00f5d4;
  --accent-purple: #7b2cbf;
  --accent-glow: rgba(0, 245, 212, 0.15);
  --color-inflow: #2ed573;
  --color-inflow-emerald: #10b981;
  --color-outflow: #ff4757;
  --color-outflow-rose: #f43f5e;
  --color-warning-amber: #f59e0b;
  --text-main: #f1f2f6;
  --text-muted: #8b92b0;
  --border-glass: rgba(255, 255, 255, 0.08);
  --shadow-premium: 0 16px 48px 0 rgba(0, 0, 0, 0.6);
  --font-family: 'Dirham', 'Dirham-Sans', 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --transition-smooth: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

select, option, optgroup {
  font-family: var(--font-family) !important;
}

.tabular-nums {
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  background-color: var(--bg-primary);
  color: var(--text-main);
  overflow-x: hidden;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-image: 
    radial-gradient(circle at 10% 20%, rgba(123, 44, 191, 0.05) 0%, transparent 40%),
    radial-gradient(circle at 90% 80%, rgba(0, 245, 212, 0.05) 0%, transparent 40%);
}

#root {
  width: 100%;
  max-width: 480px; /* Mobile viewport container styling */
  min-height: 100vh;
  background-color: var(--bg-secondary);
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  position: relative;
  border-left: 1px solid var(--border-glass);
  border-right: 1px solid var(--border-glass);
}

/* Scrollbars */
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: var(--border-glass);
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: var(--text-muted);
}

/* Glassmorphism utility */
.glass-panel {
  background: var(--bg-card);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--border-glass);
  border-radius: 24px;
  box-shadow: var(--shadow-premium);
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

@keyframes pulseGlow {
  0%, 100% { box-shadow: 0 0 15px rgba(0, 245, 212, 0.3); }
  50% { box-shadow: 0 0 30px rgba(0, 245, 212, 0.6); }
}

@keyframes pulseGlowRed {
  0%, 100% { box-shadow: 0 0 15px rgba(255, 71, 87, 0.3); }
  50% { box-shadow: 0 0 30px rgba(255, 71, 87, 0.6); }
}

.animate-fade-in {
  animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.animate-slide-up {
  animation: slideUp 0.35s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

/* Typography styles */
h1 {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

h2 {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-main);
}

h3 {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Input Fields */
input:not([type="checkbox"]):not([type="radio"]), select, textarea {
  width: 100%;
  background-color: var(--bg-input);
  border: 1px solid var(--border-glass);
  border-radius: 12px;
  padding: 14px 16px;
  color: var(--text-main);
  font-size: 16px;
  outline: none;
  transition: var(--transition-smooth);
}

input[type="checkbox"], input[type="radio"] {
  width: 18px;
  height: 18px;
  min-width: 18px;
  min-height: 18px;
  margin: 0;
  cursor: pointer;
  accent-color: var(--accent-purple);
  flex-shrink: 0;
}

input:not([type="checkbox"]):not([type="radio"]):focus, select:focus, textarea:focus {
  border-color: var(--accent-cyan);
  box-shadow: 0 0 8px var(--accent-glow);
}

label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-muted);
  margin-bottom: 6px;
  display: block;
}

/* Custom Buttons */
.btn-primary {
  background: linear-gradient(135deg, var(--accent-purple), #5e17eb);
  color: white;
  border: none;
  border-radius: 16px;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-smooth);
  box-shadow: 0 4px 15px rgba(123, 44, 191, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(123, 44, 191, 0.5);
}

.btn-secondary {
  background: var(--bg-input);
  color: var(--text-main);
  border: 1px solid var(--border-glass);
  border-radius: 16px;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-smooth);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.05);
}

/* Category Grid Item */
.category-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--bg-input);
  border: 1px solid var(--border-glass);
  border-radius: 16px;
  aspect-ratio: 1;
  cursor: pointer;
  transition: var(--transition-smooth);
  color: var(--text-main);
}

.category-btn:hover {
  border-color: var(--accent-cyan);
  background: rgba(0, 245, 212, 0.05);
  transform: scale(1.05);
}

.category-btn.active {
  border-color: var(--accent-cyan);
  background: rgba(0, 245, 212, 0.1);
  box-shadow: 0 0 12px var(--accent-glow);
}

/* Transaction List Item */
.tx-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid var(--border-glass);
  transition: var(--transition-smooth);
  cursor: pointer;
}

.tx-item:hover {
  background: rgba(255, 255, 255, 0.02);
}

/* Sliding Period Selector */
.period-selector {
  display: flex;
  overflow-x: auto;
  gap: 8px;
  padding: 12px 16px;
  scrollbar-width: none;
}

.period-selector::-webkit-scrollbar {
  display: none;
}

.period-tab {
  padding: 8px 16px;
  background: var(--bg-input);
  border: 1px solid var(--border-glass);
  border-radius: 20px;
  color: var(--text-muted);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: var(--transition-smooth);
}

.period-tab.active {
  background: var(--text-main);
  color: var(--bg-primary);
  border-color: var(--text-main);
}

/* Quick Action persistent buttons */
.quick-actions-bar {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 16px;
  background: rgba(13, 17, 23, 0.95);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  position: fixed;
  bottom: 68px;
  left: 0;
  right: 0;
  z-index: 99;
  border-top: 1px solid var(--border-glass);
}

.action-btn-minus, .action-btn-plus {
  flex: 1;
  height: 48px;
  border: none;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 700;
  color: white;
  cursor: pointer;
  transition: var(--transition-smooth);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.action-btn-minus {
  background: var(--color-outflow);
  box-shadow: 0 4px 15px rgba(255, 71, 87, 0.3);
}

.action-btn-minus:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 71, 87, 0.5);
}

.action-btn-plus {
  background: var(--color-inflow);
  box-shadow: 0 4px 15px rgba(46, 213, 115, 0.3);
}

.action-btn-plus:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(46, 213, 115, 0.5);
}

/* Responsive Category Grid */
.quick-tap-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(76px, 1fr));
  gap: 8px;
  width: 100%;
}

/* Side Menu Drawer Styles */
.side-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  justify-content: flex-start;
  animation: fadeIn 0.25s ease;
}

.side-menu-drawer {
  width: 80%;
  max-width: 320px;
  height: 100%;
  background: var(--bg-secondary);
  border-right: 1px solid var(--border-glass);
  display: flex;
  flex-direction: column;
  box-shadow: 10px 0 40px rgba(0, 0, 0, 0.6);
  animation: slideLeft 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideLeft {
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
}

.side-menu-header {
  padding: 24px 20px;
  border-bottom: 1px solid var(--border-glass);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.side-menu-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.side-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 12px;
  color: var(--text-main);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  transition: var(--transition-smooth);
}

.side-menu-item:hover {
  background: rgba(255, 255, 255, 0.03);
  border-color: var(--border-glass);
  color: var(--accent-cyan);
}

.side-menu-item.active {
  background: rgba(0, 245, 212, 0.08);
  border-color: var(--accent-cyan);
  color: var(--accent-cyan);
}

/* Responsive Grid & Desktop Styling Overrides */
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.app-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.desktop-sidebar {
  width: 260px;
  height: 100vh;
  background: var(--bg-secondary);
  border-right: 1px solid var(--border-glass);
  display: flex;
  flex-direction: column;
  z-index: 10;
}

.desktop-sidebar .side-menu-drawer {
  width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  box-shadow: none !important;
  border-right: none !important;
  animation: none !important;
}

/* Sheet Overlay as premium centered modal on Desktop */
.sheet-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--bg-secondary);
  z-index: 100;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}

/* Auth Screen Container Styles */
.auth-screen-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  justify-content: center;
  align-items: center;
  padding: 24px;
  background-color: var(--bg-primary, #0a0b10);
  box-sizing: border-box;
  width: 100%;
}

.auth-card-container {
  width: 100%;
  max-width: 440px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

@media (min-width: 768px) {
  #root {
    max-width: 100% !important;
    width: 100vw !important;
    box-shadow: none !important;
    border: none !important;
  }
  
  body {
    background-image: 
      radial-gradient(circle at 10% 20%, rgba(123, 44, 191, 0.08) 0%, transparent 40%),
      radial-gradient(circle at 90% 80%, rgba(0, 245, 212, 0.08) 0%, transparent 40%);
  }

  .app-container {
    display: grid !important;
    grid-template-columns: 260px 1fr !important;
    width: 100vw !important;
    overflow: hidden !important;
  }

  .app-body {
    height: 100vh !important;
    overflow-y: hidden !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .app-body header {
    padding: 16px 32px !important;
  }

  footer {
    display: none !important;
  }

  header button {
    display: none !important;
  }

  main {
    padding-bottom: 90px !important;
    display: flex !important;
    flex-direction: column !important;
  }

  /* Center and bound all main tab views to prevent stretching */
  main > .animate-fade-in,
  main > .friends-tab-container,
  main > div {
    max-width: 860px !important;
    margin-left: auto !important;
    margin-right: auto !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  /* Desktop Quick Actions Floating Pill Bar */
  .quick-actions-bar {
    position: fixed !important;
    bottom: 20px !important;
    left: calc(260px + (100vw - 260px) / 2) !important;
    transform: translateX(-50%) !important;
    width: calc(100% - 300px) !important;
    max-width: 860px !important;
    border-radius: 18px !important;
    border: 1px solid var(--border-glass) !important;
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.55), 0 0 20px rgba(0, 245, 212, 0.08) !important;
    backdrop-filter: blur(20px) !important;
    -webkit-backdrop-filter: blur(20px) !important;
    padding: 10px 16px !important;
    box-sizing: border-box !important;
  }

  /* Desktop Centered Sheet Modals */
  .sheet-modal {
    top: 60px !important;
    left: calc(260px + (100vw - 260px) / 2) !important;
    transform: translateX(-50%) !important;
    right: auto !important;
    width: calc(100% - 300px) !important;
    max-width: 860px !important;
    bottom: 20px !important;
    border-radius: 24px !important;
    border: 1px solid var(--border-glass) !important;
    box-shadow: var(--shadow-premium) !important;
    background: rgba(18, 20, 32, 0.96) !important;
    backdrop-filter: blur(25px) !important;
    -webkit-backdrop-filter: blur(25px) !important;
    height: calc(100vh - 80px) !important;
    box-sizing: border-box !important;
  }
}

/* Skeleton Loading Shimmer */
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.skeleton-shimmer {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.03) 25%,
    rgba(255, 255, 255, 0.08) 50%,
    rgba(255, 255, 255, 0.03) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.8s infinite cubic-bezier(0.4, 0, 0.6, 1);
  border-radius: 12px;
}

/* Modal Backdrop Blur & Spring Entrance */
@keyframes springPop {
  0% { transform: scale(0.92); opacity: 0; }
  60% { transform: scale(1.02); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh; /* Fallback for browsers that do not support dvh */
  height: 100dvh;
  z-index: 10000 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: env(safe-area-inset-top, 16px) env(safe-area-inset-right, 16px) env(safe-area-inset-bottom, 16px) env(safe-area-inset-left, 16px);
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.modal-backdrop.modal-backdrop-elevated {
  z-index: 11000 !important;
}

.modal-backdrop.modal-backdrop-edit {
  z-index: 12000 !important;
}

.modal-backdrop.modal-backdrop-alert {
  z-index: 25000 !important;
}

.modal-backdrop-blur {
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  background: rgba(8, 10, 18, 0.82);
}

.modal-spring-enter {
  animation: springPop 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.modal-content-panel {
  width: 100%;
  max-width: 440px;
  max-height: 85vh; /* Fallback */
  max-height: calc(90dvh - env(safe-area-inset-top, 16px) - env(safe-area-inset-bottom, 16px));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  padding: 20px 16px;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
  margin: auto;
}

.friends-tab-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.friend-details-panel {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

@media (max-width: 480px) {
  .modal-backdrop {
    padding: env(safe-area-inset-top, 10px) env(safe-area-inset-right, 10px) env(safe-area-inset-bottom, 10px) env(safe-area-inset-left, 10px);
    align-items: flex-end;
  }

  .modal-content-panel {
    max-width: 100% !important;
    width: 100% !important;
    max-height: calc(85dvh - env(safe-area-inset-bottom, 0px)) !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-top-left-radius: 24px !important;
    border-top-right-radius: 24px !important;
    padding: 18px 14px calc(18px + env(safe-area-inset-bottom, 0px)) !important;
  }

  .friends-tab-container {
    padding: 14px 10px !important;
    gap: 12px !important;
  }

  .friend-details-panel {
    padding: 16px 12px !important;
    gap: 12px !important;
  }
}

/* Contextual Financial Highlights */
.highlight-inflow {
  border-left: 4px solid var(--color-inflow-emerald) !important;
  background: linear-gradient(90deg, rgba(16, 185, 129, 0.06) 0%, transparent 100%);
}

.highlight-outflow {
  border-left: 4px solid var(--color-outflow-rose) !important;
  background: linear-gradient(90deg, rgba(244, 63, 94, 0.06) 0%, transparent 100%);
}

.highlight-amber-warning {
  border: 1px solid var(--color-warning-amber) !important;
  box-shadow: 0 0 20px rgba(245, 158, 11, 0.25) !important;
}

/* SVG Success Checkmark Animation Keyframes */
@keyframes strokeDraw {
  100% { stroke-dashoffset: 0; }
}

@keyframes scaleCheckmark {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.12); }
}

.checkmark-circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 3;
  stroke-miterlimit: 10;
  stroke: #10b981;
  fill: none;
  animation: strokeDraw 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark-check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: strokeDraw 0.4s cubic-bezier(0.65, 0, 0.45, 1) 0.5s forwards, scaleCheckmark 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.6s;
}

/* Touch Target Standardizer */
.touch-target {
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* --- LOGO REVEAL & PWA LOADING ANIMATION --- */
@keyframes pwaLogoReveal {
  0% {
    opacity: 0;
    transform: scale(0.65) translateY(10px);
    filter: blur(6px);
  }
  60% {
    opacity: 1;
    transform: scale(1.06) translateY(0);
    filter: blur(0px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
    filter: blur(0px);
  }
}

@keyframes pwaLogoRingGlow {
  0%, 100% {
    filter: drop-shadow(0 0 16px rgba(0, 245, 212, 0.35)) drop-shadow(0 0 35px rgba(0, 245, 212, 0.15));
  }
  50% {
    filter: drop-shadow(0 0 28px rgba(0, 245, 212, 0.65)) drop-shadow(0 0 55px rgba(0, 245, 212, 0.3));
  }
}

@keyframes pwaLine1Reveal {
  0% {
    opacity: 0;
    transform: translateY(12px);
    letter-spacing: -2px;
  }
  100% {
    opacity: 1;
    transform: translateY(0);
    letter-spacing: -0.5px;
  }
}

@keyframes pwaLine2Reveal {
  0% {
    opacity: 0;
    transform: translateY(10px);
    letter-spacing: 0.04em;
  }
  100% {
    opacity: 0.9;
    transform: translateY(0);
    letter-spacing: 0.14em;
  }
}

.logo-reveal-img {
  animation: pwaLogoReveal 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards, pwaLogoRingGlow 3s ease-in-out infinite 0.8s;
  width: 96px;
  height: 96px;
  border-radius: 22px;
  object-fit: contain;
}

.logo-reveal-line1 {
  font-size: 34px;
  font-weight: 800;
  color: var(--text-main);
  animation: pwaLine1Reveal 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.2s forwards;
  opacity: 0;
  margin-top: 14px;
  letter-spacing: -0.5px;
}

.logo-reveal-line2 {
  font-size: 13px;
  font-weight: 600;
  color: var(--accent-cyan);
  text-transform: uppercase;
  animation: pwaLine2Reveal 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.4s forwards;
  opacity: 0;
  margin-top: 4px;
}

/* --- Live Market & Lightweight Chart Utilities --- */
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.spinner-inline {
  display: inline-block;
  animation: spin 0.8s linear infinite;
}

.hover-card {
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}
.hover-card:hover {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(0, 245, 212, 0.3) !important;
  transform: translateY(-1px);
}

.hover-row {
  transition: background 0.15s ease;
}
.hover-row:hover {
  background: rgba(0, 245, 212, 0.03) !important;
}

/* --- Custom Account Select (Portal Modal & Mobile Bottom Sheet) --- */
.account-select-backdrop {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  height: 100dvh !important;
  z-index: 15000 !important;
  background: rgba(5, 7, 14, 0.78) !important;
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 20px !important;
  box-sizing: border-box !important;
}

.account-select-panel {
  width: 100% !important;
  max-width: 480px !important;
  background: #141824 !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-radius: 20px !important;
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.95) !important;
  padding: 20px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 12px !important;
  max-height: 80vh !important;
  box-sizing: border-box !important;
  animation: springPop 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards !important;
}

.account-select-pill-handle {
  display: none;
}

@media (max-width: 768px) {
  .account-select-backdrop {
    padding: 0 !important;
    align-items: flex-end !important;
  }

  .account-select-panel {
    max-width: 100% !important;
    border-radius: 24px 24px 0 0 !important;
    border-bottom: none !important;
    padding: 14px 16px calc(24px + env(safe-area-inset-bottom, 16px)) 16px !important;
    max-height: calc(85dvh - env(safe-area-inset-bottom, 0px)) !important;
    animation: slideUpSheet 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards !important;
  }

  .account-select-pill-handle {
    display: block;
    width: 40px;
    height: 4px;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 2px;
    margin: 0 auto 10px auto;
  }
}

@keyframes slideUpSheet {
  from {
    transform: translateY(100%);
    opacity: 0.8;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Thinking Orbs Button Pop-up Animation */
@keyframes orbPopupSpring {
  0% {
    opacity: 0;
    transform: scale(0.65) translateY(14px);
  }
  60% {
    opacity: 1;
    transform: scale(1.04) translateY(-2px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.thinking-orb-popup {
  position: fixed;
  z-index: 100000;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 28px;
  border-radius: 24px;
  background: rgba(10, 11, 16, 0.94);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
  animation: orbPopupSpring 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
  transition: top 0.12s ease, left 0.12s ease;
  user-select: none;
}

/* Swipable Pending Actions Carousel */
.pending-actions-carousel {
  display: flex;
  flex-direction: row;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  padding: 4px 2px 10px 2px;
  margin: 0 -2px;
}

.pending-actions-carousel::-webkit-scrollbar {
  height: 4px;
}

.pending-actions-carousel::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 4px;
}

.pending-actions-carousel::-webkit-scrollbar-thumb {
  background: rgba(0, 245, 212, 0.25);
  border-radius: 4px;
}

.pending-actions-carousel::-webkit-scrollbar-thumb:hover {
  background: var(--accent-cyan);
}

.pending-action-card {
  scroll-snap-align: start;
  scroll-snap-stop: normal;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--border-glass);
  border-radius: 12px;
  padding: 12px 14px;
  box-sizing: border-box;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.pending-action-card:hover {
  border-color: rgba(0, 245, 212, 0.2);
}

